import './index.scss';
import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';
import { SettingsPage } from './components';

import './blocks/dynamic-listings';
import './blocks/listings';

domReady( () => {
	const rootElement = document.getElementById( 'linear-react-settings' );

	if ( ! rootElement ) {
		return;
	}

	createRoot( document.getElementById( 'linear-react-settings' ) ).render( <SettingsPage /> );
} );
